import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import OrganizationAppResource from "./OrganizationAppResource";

class OrganizationMoxiOfficeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'organization-moxi-office';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'organizations/moxi/offices';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'organizationUuid',
            'moxiWorksOfficeId',
            'officeId',
            'companyNumericId',
            'companyId',
            'name',
            'address',
            'city',
            'state',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organization: OrganizationAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            organization: 'organization_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            organizationUuid: {
                type: 'string',
                presence: {
                    message: "^Organization can't be blank."
                },
            },
            moxiWorksOfficeId: {
                presence: true,
                type: 'string',
            },
            officeId: {
                presence: true,
                numericality: true,
            },
            companyNumericId: {
                presence: true,
                numericality: true,
            },
            companyId: {
                presence: true,
                type: 'string',
            },
            name: {
                presence: true,
                type: 'string',
            },
            address: {
                type: 'string',
            },
            city: {
                type: 'string',
            },
            state: {
                type: 'string',
            },
        };
    }
}

export default OrganizationMoxiOfficeAppResource;
